import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const StyledStack = styled(Stack)`
  /* border-bottom: 1px solid lightgray; */
  width: 100%;
`;
